import $ from 'jquery';
import Cookies from "js-cookie";

function checkAndDisplayCookieNotice() {
  const cookieName = 'datenschutzerklaerung.em-immo.at';

  $('.cookie-notice button').click(function() {
    console.log('cookie button clicked');
    Cookies.set(cookieName, 'accepted', { expires: 365 });
    $('.cookie-notice').hide();
  });

  var accepted = (Cookies.get(cookieName) == 'accepted');
  if (!accepted) {
    $('.cookie-notice').show();
  }
}

$(() => {
  checkAndDisplayCookieNotice();
});
